export const TerminalActionStatus = {
  0: "OK",
  1: "ERROR",
};

export const TerminalActionSource = {
  0: "Back Office",
  1: "TERMINAL",
};
